// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".proposal-modal .ant-modal-close {\n  margin-top: 28px;\n  margin-right: 28px;\n}\n.proposal-modal .ant-modal-close .ant-modal-close-x {\n  font-size: 40px;\n  color: white;\n}\n", ""]);
// Exports
module.exports = exports;
